module.exports = __webpack_public_path__ + "img/img24.aa13b91a.svg";